import React from "react";
import { Link } from "react-router-dom";
import { formatBlogDate } from "./blogUtils";
import { resolveBlogImageUrl } from "./blogApi";

function BlogCard({ article }) {
  const publishedAt = article.publishedAt || article.date;
  const articleImage = resolveBlogImageUrl(article.ogImage);

  return (
    <Link
      className="article-card"
      to={`/blog/${article.slug}`}
      data-testid="blog-card"
      aria-label={`Открыть статью ${article.title}`}
    >
      <div className="article-card__media">
        <img
          className="article-card__image"
          src={articleImage}
          alt={article.title}
          loading="lazy"
        />
        <span className="article-card__type">{article.contentType}</span>
      </div>
      <div className="article-card__eyebrow">
        <span>{formatBlogDate(publishedAt)}</span>
        <span>{article.category}</span>
        <span>{article.readingTime} мин чтения</span>
      </div>
      <h3 className="article-card__title">{article.title}</h3>
      <p className="article-card__description">{article.description}</p>
      <div className="article-card__tags" aria-label="Теги статьи">
        {(article.tags || []).map((tag) => (
          <span className="article-card__tag" key={tag}>
            {tag}
          </span>
        ))}
      </div>
      <span className="article-card__cta">Читать статью →</span>
    </Link>
  );
}

export default BlogCard;
